import { Button, Link, TableBody, TableCell, TableRow } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'

import React, { FC } from 'react'

import { ProductListInterface } from '../../interfaces/product'
import { convertDateTimeToString } from '../../utils/common'

type Props = {
  productList: ProductListInterface[]
  archiveProduct: (productId: string) => () => void
  handleOpenProductForm: (productId?: string) => () => void
}

const CompanyProductTableBody: FC<Record<string, unknown> & Props> = ({
  productList,
  archiveProduct,
  handleOpenProductForm
}: Props) => (
  <TableBody>
    {productList.map((product: ProductListInterface) => (
      <TableRow key={product.productId} hover={true}>
        <TableCell align="center">
          <Link onClick={handleOpenProductForm(product.productId)}>
            {product.productId}
          </Link>
        </TableCell>
        <TableCell align="center">{product.name}</TableCell>
        <TableCell align="center">{product.category.name}</TableCell>
        <TableCell align="center">
          {convertDateTimeToString(product.updatedTime)}
        </TableCell>
        <TableCell align="center">{product.updatedByEmail}</TableCell>
        <TableCell align="center">
          <Button
            variant="contained"
            color="secondary"
            onClick={archiveProduct(product.productId)}
          >
            <DeleteIcon />
            Archive
          </Button>
        </TableCell>
      </TableRow>
    ))}
  </TableBody>
)

export default CompanyProductTableBody
